export interface CalendarEvent {
  eventName: string;
  dateStart: string;
  dateEnd: string;
  description?: string;
  location?: string;
}
const formatCalendarDate = (date: Date): string => {
  return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
};
export const generateIcsContent = (event: CalendarEvent): string => {
  const startDate = new Date(event.dateStart);
  const endDate = new Date(event.dateEnd);
  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Sminex//Event Calendar//EN',
    'METHOD:PUBLISH',
    'CALSCALE:GREGORIAN',
    'BEGIN:VEVENT',
    `DTSTART:${formatCalendarDate(startDate)}`,
    `DTEND:${formatCalendarDate(endDate)}`,
    `SUMMARY:${event.eventName}`,
    `DTSTAMP:${formatCalendarDate(new Date())}`,
    `UID:${Date.now()}@sminex.com`,
    'STATUS:CONFIRMED',
    'SEQUENCE:0',
    'TRANSP:OPAQUE',
    ...(event.description ? [`DESCRIPTION:${event.description}`] : []),
    ...(event.location ? [`LOCATION:${event.location}`] : []),
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');
  return icsContent;
};
export const downloadIcsFile = (event: CalendarEvent): void => {
  const icsContent = generateIcsContent(event);
  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${event.eventName}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
// Генерируем Google календарь URL для Android
export const generateGoogleCalendarUrl = (event: CalendarEvent): string => {
  const startDate = new Date(event.dateStart);
  const endDate = new Date(event.dateEnd);

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: event.eventName,
    dates: `${formatCalendarDate(startDate)}/${formatCalendarDate(endDate)}`,
    ...(event.description && { details: event.description }),
    ...(event.location && { location: event.location }),
  });

  return `https://www.google.com/calendar/render?${params.toString()}`;
};
// Провреяем, является ли браузер Safari
export const isSafari = (): boolean => {
  const userAgent = navigator.userAgent;
  return /Safari/i.test(userAgent) && !/Chrome|CriOS|Chromium/i.test(userAgent);
};
// Провреяем, является ли устройство iOS
export const isIOS = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor;
  return /iPad|iPhone|iPod/i.test(userAgent);
};
// Провреяем, является ли устройство Android
export const isAndroid = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor;
  return /Android/i.test(userAgent);
};
// Показываем кнопку Добавить в календарь для Android всегда показываем и для если iOS + Safari
export const isMobileDevice = (): boolean => {
  if (isAndroid()) {
    return true;
  }
  if (isIOS() && isSafari()) {
    return true;
  }
  return false;
};
